var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import styled, { css } from 'styled-components';
import { Button } from '../../forms';
import { Flexbox } from '../../layout';
import { color } from '../../styles';
import { Text } from '../../typography';
var Circle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 128px;\n  width: 128px;\n  ", "\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: 128px;\n  width: 128px;\n  ", "\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) {
    return props.size === 'smaller' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 116px;\n      width: 116px;\n    "], ["\n      height: 116px;\n      width: 116px;\n    "])));
}, function (props) { return color(props.color || 'sidebarHover'); });
var EmptyState = (function (_super) {
    __extends(EmptyState, _super);
    function EmptyState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyState.prototype.render = function () {
        var _a, _b, _c;
        var props = this.props;
        return (_jsxs(Flexbox, __assign({ justifyContent: "center", flexDirection: "column", alignItems: "center" }, { children: [props.icon && (_jsx(Circle, __assign({ style: { marginBottom: '1rem' }, size: (_a = props.variant) === null || _a === void 0 ? void 0 : _a.circle, color: (_b = props.variant) === null || _b === void 0 ? void 0 : _b.color }, { children: props.icon }))), props.title && (_jsx(EmptyState.Title, { variant: (_c = props.variant) === null || _c === void 0 ? void 0 : _c.title, children: props.title })), props.subtitle && _jsx(EmptyState.SubTitle, { children: props.subtitle }), _jsx("div", { style: { height: '0.5rem' } }), props.children] })));
    };
    EmptyState.Title = function (_a) {
        var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'semiBold' : _b;
        return (_jsx(Text, __assign({ size: variant === 'bold' ? 'h4_new' : 'body1_new', fontWeight: variant }, { children: children })));
    };
    EmptyState.SubTitle = function (_a) {
        var children = _a.children;
        return (_jsx(Text, __assign({ size: "body1_new", style: { marginBottom: 10 } }, { children: children })));
    };
    EmptyState.CTA = function (_a) {
        var onClick = _a.onClick, children = _a.children;
        return (_jsx("div", __assign({ className: "mt2" }, { children: _jsx(Button, __assign({ onClick: onClick, color: "primary" }, { children: children })) })));
    };
    return EmptyState;
}(Component));
export default EmptyState;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map